import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export function PersonOutlineIcon(props: SVGProps): JSX.Element {
  const { title = 'Person outline icon', className, ...restProps } = props;

  return (
    <svg
      className={cn('fill-current', className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      {...restProps}
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00008 2C7.06709 2 5.50008 3.567 5.50008 5.5C5.50008 7.433 7.06709 9 9.00008 9C10.9331 9 12.5001 7.433 12.5001 5.5C12.5001 3.567 10.9331 2 9.00008 2ZM3.50008 5.5C3.50008 2.46243 5.96252 0 9.00008 0C12.0376 0 14.5001 2.46243 14.5001 5.5C14.5001 8.53757 12.0376 11 9.00008 11C5.96252 11 3.50008 8.53757 3.50008 5.5ZM6.32635 12.5C6.38341 12.5 6.44132 12.5 6.50009 12.5H11.5001C11.5589 12.5 11.6168 12.5 11.6738 12.5C12.9011 12.4995 13.7391 12.4992 14.4515 12.7153C16.0495 13.2 17.3 14.4506 17.7848 16.0486C18.0009 16.761 18.0006 17.599 18.0001 18.8263C18.0001 18.8833 18.0001 18.9412 18.0001 19V20H16.0001V19C16.0001 17.5317 15.9892 17.0192 15.8709 16.6291C15.5801 15.6703 14.8297 14.92 13.8709 14.6292C13.4809 14.5108 12.9684 14.5 11.5001 14.5H6.50009C5.03177 14.5 4.51929 14.5108 4.12923 14.6292C3.17042 14.92 2.42011 15.6703 2.12926 16.6291C2.01094 17.0192 2.00008 17.5317 2.00008 19V20H8.32751e-05V19C8.32751e-05 18.9412 6.18174e-05 18.8833 4.07174e-05 18.8263C-0.000413351 17.599 -0.000723422 16.761 0.215383 16.0486C0.700134 14.4506 1.95065 13.2 3.54866 12.7153C4.26106 12.4992 5.09908 12.4995 6.32635 12.5Z"
      />
    </svg>
  );
}
